/* eslint-disable i18next/no-literal-string */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom-v5-compat";
import { CreateSessionResponseEnum } from "@b2bportal/auth-api";
import { createSession } from "@b2bportal/core-auth";
import { Select, SelectItem } from "@b2bportal/core-ui";
import { ActionButton } from "@hopper-b2b/ui-core";
import { useAuth } from "@hsbc/auth";
import { isProductionEnv, isThirdPartyDomain } from "@hsbc/utilities";
import { HOME_PATH } from "@hsbc/utilities";
import clsx from "clsx";
import { v4 as uuidv4 } from "uuid";
import "./styles.scss";

// TODO: Pass in config in a better way
const version = import.meta.env.VITE_REACT_APP_VERSION ?? `local-${uuidv4()}`;

export const MockLoginPage = () => {
  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isThirdPartyDomain()) {
      navigate(HOME_PATH, { replace: true });
    }
  }, [navigate]);

  const testMockUsers = [
    { userName: "QA Mock User 1", rancu: "320922594505941139343450028003" },
    { userName: "QA Mock User 2", rancu: "914115650045243109983945330399" },
  ];

  const prodMockUsers = [
    {
      userName: "Viral Khokhani HSBC (DO NOT USE POINTS)",
      rancu: "776159581367230719729331854077",
    },
  ];

  const testUsers = isProductionEnv() ? prodMockUsers : testMockUsers;

  const [selectedUser, setSelectedUser] = useState(testUsers[0]);

  const onLoginClick = async () => {
    try {
      const res = await createSession({
        CreateSessionRequest: "SignIn",
        authMethod: {
          AuthMethod: "GoogleIdentityBased",
          idToken: selectedUser.rancu,
        },
      });
      if (
        res.CreateSessionResponse ===
        CreateSessionResponseEnum.CreateSessionSuccess
      ) {
        login();
        navigate(HOME_PATH);
      } else {
        console.log("create session rejected:", res.CreateSessionResponse);
      }
    } catch (error) {
      console.error("error creating session info:", error);
    }
  };

  return (
    <div className={clsx("hsbc-mock-login-page")}>
      <h3>Please select a user to login:</h3>
      <Select
        placeholder={"Select a user"}
        defaultValue={selectedUser.rancu}
        onValueChange={(v) =>
          setSelectedUser(testUsers.find((u) => u.rancu === v)!)
        }
      >
        {testUsers.map((user) => {
          return (
            <SelectItem key={user.rancu} value={user.rancu}>
              {user.userName}
            </SelectItem>
          );
        })}
      </Select>

      <ActionButton
        size="medium"
        message={"Login"}
        className="login-button"
        onClick={onLoginClick}
      />

      <span className={"version"}>{version}</span>
    </div>
  );
};
